import React from 'react'

const EditPatient = () => {
  return (
    <div>EditPatient</div>
  )
}

export default EditPatient